import SAPOMailConfig from "@/SAPOMailConfig";
import HTTPService    from "@/js/Shared/Services/HTTP/HTTPService";

export { MessagesOptionsHTTPService as default };

/**
* Email messages options HTTP Service
*
* @author      rsimoes <ruben-r-simoes@telecom.pt>
* @copyright   Copyright (C) Sapo. All rights reserved.
* @license     Private
* @since       7.0.0
*/
class MessagesOptionsHTTPService {
  /**
   * Contacts Enpoint
   *
   * @public
   *
   * @type {string}
   *
   * @since 7.0.0
   */
  endpoint = SAPOMailConfig.client.endpoints.settings.generic;

 /**
   * Calls backend api to fetch messages options settings
   *
   * @public
   *
   * @since 7.0.0
   *
   * @return {Promise.<HTTPResponseEntity>}
   */
  async fetchOptions() {
    let response = await HTTPService.post(
      this.endpoint + '?api=1&app=imp&group=genericGroup',
      null,
      'fetch_message_options',
    );

    return response;
  }

  /**
   * Calls backend api to add a new person
   *
   * @public
   *
   * @since 7.0.0
   *
   * @param {MessagesOptionsEntity} options options entity
   *
   * @return {Promise.<HTTPResponseEntity>}
   */
  async saveOptions(options) {
    let request = {
      actionID          : 'update_prefs',
      api               : 1,
      app               : 'imp',
      group             : 'genericGroup',
      horde_prefs_token : SAPOMailConfig.server.security.settings_token,
      request_mdn       : options.request_mdn ? 'always' : 'never',
    }

    if (options.image_replacement) {
      request.image_replacement = 1;
    }

    let response = await HTTPService.post(
      this.endpoint + '?api=1',
      request,
    );

    return response;
  }
}